// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:768px){.pC33S{padding:32px;border:1px solid #e2e2e2;background:#fff;border-radius:8px}}@media screen and (min-width:1552px){.pC33S{padding:40px 88px 40px 72px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articleRatingAbout": "pC33S"
};
module.exports = ___CSS_LOADER_EXPORT___;
